export default {
  address: 'Osoite',
  contact: 'Yhteystiedot',
  terms: 'Käyttöehdot',
  privacy_policy: 'Tietosuojakäytäntö',
  impressum: 'Yritystiedot',
  cookie_policy: 'Evästekäytäntö',
  cookie_settings: 'Evästeasetukset',
};
